import React, { PureComponent, CSSProperties, ReactElement } from 'react';
import classnames from 'classnames';
import styles from './mask.module.css';

export type MaskProps = {
	mask: ReactElement;
	maskVisible?: boolean;
	className?: string;
};

export class Mask extends PureComponent<MaskProps> {
	render() {
		const { mask, maskVisible, className, children } = this.props;

		return (
			<div className={classnames(styles.maskContainer, className)}>
				{children}
				<div
					className={classnames(styles.mask, 'abs-overlay', {
						[styles.maskHidden]: !maskVisible,
					})}
				>
					{mask}
				</div>
			</div>
		);
	}
}
